import { language } from '@tencent/ppd-base-libs';
import { getBannerConfig } from './api';
import { BannerConfig } from './types';

/**
 * 获取banner配置
 * @param bannerConfigUrl: banner配置地址
 * @returns boolean
 */
export const getConfig = async (bannerConfigUrl: string): Promise<BannerConfig[]> => {
  const bannerConfigArr = await getBannerConfig(bannerConfigUrl);
  const lang = language.getLanguage().toLowerCase().replace(/-/g, '_');
  // 格式化，处理多语言
  const config: BannerConfig[] = bannerConfigArr.map((item) => {
    const configItem: BannerConfig = {
      seq: item.seq,
      bannerImgUrl: item.bannerImgUrl[lang],
      bannerJumpUrl: item.bannerJumpUrl[lang],
      bannerTime: item.bannerTime,
      bannerTag: item.bannerTag,
    };
    return configItem;
  });
  // 排序
  config.sort((a, b) => a.seq - b.seq);
  return config;
};
